jQuery($ => {
    class Universal_Header {
        constructor(element) {
            this._ = element;
            this._element = $(element);

            this._trigger = this._element.find('.o-universal-header__trigger-link');
            this._megaNav = this._element.find('.m-nav-menu-dropdown-block');
            this._mobileTrigger = this._element.find('.o-universal-header__mobile-menu-trigger');
            this._menu = this._element.find('.o-universal-header__menu');
            this._bodyHTML = $('body');

            this.init();
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this._element.trigger('init', this);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupHandlers() {
            this._trigger.on('click', (e) => {
                e.preventDefault();

                if (e.target.classList.contains('o-universal-header__trigger-link--active')) {
                    this.handleMegaNavClose(e);
                } else {
                    this.handleMegaNavOpen(e);
                }
            });

            this._trigger.on('blur', (e) => this.handleBlur(e));
            this._element.on('keydown', this.handleKeydown);

            this._mobileTrigger.on('click', this.toggleMenu);
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Header Open
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleHeaderOpen = () => {
            this._element.addClass('o-universal-header--open');
            this._bodyHTML.addClass('fixed');
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Header Close
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleHeaderClose = () => {
            this._menu.removeClass('o-universal-header__menu--open');
            this.handleMegaNavClose();
            this._bodyHTML.removeClass('fixed');
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // _Handle Menu Open
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        toggleMenu = () => {
            this._menu.toggleClass('o-universal-header__menu--open');
            this._bodyHTML.toggleClass('fixed');
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Mega Nav Open
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleMegaNavOpen(e) {
            this._megaNavID = $(e.target).attr('aria-controls');
            this._megaNav = $(`#${this._megaNavID}`);

            this._megaNav.nav_menu_dropdown_block('handleActivate');
            $(e.target).addClass('o-universal-header__trigger-link--active');

            this._trigger.not(e.target).removeClass('o-universal-header__trigger-link--active');
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Mega Nav Close
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleMegaNavClose(e) {
            this._trigger.removeClass('o-universal-header__trigger-link--active');
            this._megaNav.nav_menu_dropdown_block('handleDeactivate');
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Blur
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleBlur = event => {
            if (
                event.relatedTarget === null ||
                (!$(event.relatedTarget).closest(".m-nav-menu-dropdown-block")[0] &&
                    !$(event.relatedTarget).is(".m-nav-menu-dropdown-block") &&
                    !$(event.relatedTarget).is(".o-universal-header__trigger-link[aria-controls]"))
            ) {
                this.handleMegaNavClose();
            }
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Key Down
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleKeydown = event => {
            switch (event.key) {
                case 'Tab':
                    const $firstFocusable = this._focusable[0];
                    const $lastFocusable = this._focusable[this._focusable.length - 1];

                    if (
                        ($(event.target).is($lastFocusable) && !event.shiftKey) ||
                        ($(event.target).is($firstFocusable) && event.shiftKey)
                    ) {
                        event.preventDefault();

                        if ($(event.target).is($lastFocusable)) {
                            $firstFocusable.focus();
                        } else {
                            $lastFocusable.focus();
                        }
                    } else if ($(event.target).is(".o-universal__trigger-link")) {
                        event.preventDefault();

                        $firstFocusable.focus();
                    }
                    break;

                case 'Escape':
                case 'Esc':
                    this.handleClose();
            }
        }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.universal_header = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].header = new Universal_Header(_[i], opt);
            else
                ret = _[i].header[opt].apply(_[i].universal_header, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.o-universal-header').universal_header();
});